import messages from './info-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsInfoModal',
    data() {
        return {
            submitSuccess: false,
            submitError: false,
        };
    },
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#info-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#info-modal').removeClass('animate-flex-modal');
            this.submitError = false;
            this.submitSuccess = false;
        },
    },
    mounted() {
        this.$on('showInfoModal', this.show());
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/info-modal/info-modal.js